<template src="../template/reg_3.html"></template>

<script>
import _ from 'lodash'
import { mapState, mapGetters, mapMutations } from 'vuex'
import { startToWatchGps, sendGeoLocation } from '../utils/geolocationUtil'

export default {
  name: 'Reg-3',
  computed: {
    ...mapState(['PROJECT_ID', 'QR_CODE', 'USER_GENDER', 'USER_AGE_RANGE']),
    ...mapGetters(['getProjectId', 'getQRCode', 'getUserGender', 'getUserAgeRange'])
  },
  created: function () {
    if (window.localStorage.getItem('gpsTimeID') !== null) {
      // console.info(`======: ${window.localStorage.getItem('gpsTimeID')}`)
      clearInterval(parseInt(window.localStorage.getItem('gpsTimeID')))
      window.localStorage.removeItem('gpsTimeID')
    }
    startToWatchGps()
    sendGeoLocation(this.getProjectId, this.getQRCode, 'Reg-3')
    const timeoutID = window.setInterval(
      () => {
        sendGeoLocation(this.getProjectId, this.getQRCode, 'Reg-3')
      }, 15000
    )
    // console.info(`timeoutID: ${timeoutID}`)
    window.localStorage.setItem('gpsTimeID', timeoutID)
    if (_.isEmpty(this.getProjectId) || _.isEmpty(this.getQRCode)) {
      this.$swal({
        title: '找不到專案代碼與 QR Code',
        text: '系統將自動導至官網',
        type: 'error'
      }).then(function (result) {
        if (result.value) {
          window.location.href = window.localStorage.getItem('projectOfficialSite')
        }
      })
    }
  },
  methods: {
    ...mapMutations(['setUserAgeRange']),
    submit (ageRange) {
      this.setUserAgeRange(ageRange)
      this.$router.push('reg-4')
    }
  }
}
</script>
